(function () {
  const initAnnBar = () => {
    const annBar = document.querySelector(".section-announcement");

    let observer;
    const createObserver = () => {
      if (observer) observer.disconnect();
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const annBarHeight = annBar?.getBoundingClientRect().height || 0;
              document.documentElement.style.setProperty(
                "--ann-height",
                `${(annBarHeight * entry.intersectionRatio).toFixed(2)}px`
              );
            } else {
              document.documentElement.style.setProperty("--ann-height", "0px");
            }
          });
        },
        {
          threshold: Array.from({ length: 1000 }, (_, i) => i / 1000),
        }
      );

      if (annBar) observer.observe(annBar);
    };
    createObserver();
  };

  document.addEventListener("shopify:section:load", initAnnBar);
  document.addEventListener("shopify:section:unload", initAnnBar);
  document.addEventListener("shopify:section:reorder", initAnnBar);

  initAnnBar();
})();

// Sticky announcement custom element
class StickyAnnouncement extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.annBar = this.querySelector('.announcement-bar');
    this.announceSection = this.closest('.section-announcement');
    if (!this.annBar || !this.announceSection) return;
    
    this.currentScrollTop = 0;
    this.annBarBounds = {};

    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries) => {
      this.annBarBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    if (this.annBar) {
      observer.observe(this.annBar);
    }
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.currentScrollTop && scrollTop > this.annBarBounds.bottom) {
      // Scrolling down
      this.hide();
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.annBarBounds.bottom) {
      // Scrolling up
      this.reveal();
    } else if (scrollTop <= this.annBarBounds.top) {
      // At top of page
      this.reset();
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    this.announceSection.classList.add('announcement-bar--hidden');
  }

  reveal() {
    this.announceSection.classList.remove('announcement-bar--hidden');
  }

  reset() {
    this.announceSection.classList.remove('announcement-bar--hidden');
  }
}

customElements.define('sticky-announcement', StickyAnnouncement);